<script setup lang="ts" generic="T extends string">
import { ref } from "vue";
import { context } from "../../context/context";
import BooleanBox, { type BooleanBoxModePattern } from "./BooleanBox.vue";
import { ColorPattern } from "@zyzgroup/core-web";

// for merge ce shadow-root styles
defineOptions({
  customOptions: { BooleanBox }
});

const props = withDefaults(
  defineProps<{
    options: Array<T>;
    disabledIndexs?: Array<number>;
    initIndex?: number;

    mode?: BooleanBoxModePattern;
    colorPattern?: ColorPattern;

    itemPadding?: string;
    labelPadding?: string;
  }>(),
  {
    initIndex: 0,

    mode: "primary-round",
    colorPattern: context.store.getState().color
      .colorPattern as unknown as ColorPattern,

    itemPadding: "10px",
    labelPadding: "2px"
  }
);

const emits = defineEmits<{
  (event: "change", values: T): void;
}>();

const booleanBoxRefs = ref<any[]>([]);
const setRef = (el: any, index: number) => {
  if (el) {
    booleanBoxRefs.value[index] = el;
  }
};

let selectedIndex = ref(props.initIndex);

const change = (index: number, selected: boolean) => {
  if (selectedIndex.value !== index) {
    booleanBoxRefs.value[selectedIndex.value].toggleValue();
    if (selected) {
      selectedIndex.value = index;
      emits("change", props.options[selectedIndex.value]);
    }
  } else {
    if (!selected) {
      // 强制选择
      booleanBoxRefs.value[selectedIndex.value].forceValue(true);
    }
  }
};
</script>

<template>
  <div
    class="radio-group"
    v-for="(option, index) in options"
    :key="index"
    :style="['margin-left:' + (index > 0 ? props.itemPadding : 0)]"
  >
    <BooleanBox
      :ref="(el) => setRef(el, index)"
      :mode="props.mode"
      :colorPattern="props.colorPattern"
      :selected="selectedIndex == index"
      :disabled="
        disabledIndexs && disabledIndexs.findIndex((i) => i === index) >= 0
      "
      @change="(v) => change(index, v)"
    ></BooleanBox>
    <span
      v-if="option"
      :style="['font-size:1em', 'margin-left:' + props.labelPadding]"
    >
      {{ option }}
    </span>
  </div>
</template>

<style scoped>
.radio-group {
  position: relative;
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
}
</style>
